/**
 * 单例模式的编辑焦点管理器
 */

import { EditingFocusManager } from '@puppycad/cad-core';

const editingFocusManager = new EditingFocusManager();

export function useEditingFocusManager(): EditingFocusManager {
  return editingFocusManager;
}

export function disposeEditingFocusManager(): void {
  editingFocusManager.dispose();
}